import React from "react";
import { Link } from "react-router-dom";
import ImageHelper from "../Helpers/ImageHelper";

const About = (props) => {
  const { aboutPage } = props;
  return (
    <>
      <section
        className={
          aboutPage === true ? "home-about-area" : "home-about-area pt-120"
        }
      >
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-lg-6 col-md-6 home-about-left">
              {/* <img draggable="false" className="img-fluid"
						src="https://res.cloudinary.com/tzcreation/image/upload/v1629292444/assets/imgs/hero_img_qvhl2l.png"
						alt="" style="margin-top:30px;" /> */}
              <img
                draggable="false"
                className="img-fluid"
                src={ImageHelper.AboutImage}
                alt=""
              />
            </div>
            <div className="col-lg-5 col-md-6 home-about-right">
              <span>Senior Product, Design &amp; Engineering Talent</span>
              <h1 className="text-uppercase">
                Built to embed, not just deliver
              </h1>
              <p>
                We're a product design and frontend engineering partner that
                works inside your team, not around it. Our work spans
                healthcare, edtech, and HR tech platforms — shipped products,
                not just mockups. Whether you need one senior hire's worth of
                capacity or a dedicated pod, we embed fast and stay
                accountable to your roadmap, not ours.
              </p>
              {aboutPage === true ? null : (
                <Link className="primary-btn text-uppercase" to="/about">
                  Read More
                </Link>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-3">
              <div className="single-services">
                <span className="lnr lnr-magic-wand"></span>
                <h4>Embedded, Not Outsourced</h4>
                <p>
                  You get a dedicated designer or engineer who joins your
                  standups, not a ticket queue.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-3">
              <div className="single-services">
                <span className="lnr lnr-book"></span>
                <h4>Senior by Default</h4>
                <p>
                  Every placement has shipped real products — not junior bench
                  time learning on your clock.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-3">
              <div className="single-services">
                <span className="lnr lnr-map"></span>
                <h4>Domain Fluent</h4>
                <p>
                  Healthcare, edtech, and HR tech workflows aren't new to us —
                  less ramp-up, faster context.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-3">
              <div className="single-services">
                <span className="lnr lnr-laptop-phone"></span>
                <h4>Scoped to Fit</h4>
                <p>
                  Need one role or a full pod? Staff augmentation, a dedicated
                  team, or a scoped project — pick what matches the work.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
